import { createStyles } from '@material-ui/core';
export default createStyles({ root: { '&.MuiSnackbar-anchorOriginTopCenter': { top: '80px' } } });
